import { call, put, select } from 'redux-saga/effects';
import cirrusClient from '../../../services/api/cirrus-client';
import { deleteMessageSession } from '../../../state/message/messageSessionSlice';
import { showSnackbar } from '../../../state/snackbar/snackbarSlice';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';

export function* deleteMessageSessionSaga(action) {
    const { messageSessionId } = action.payload;
    console.log('this is message session id', messageSessionId)
    try {
        const { domain, user } = yield select(selectUserCredentials);

        const response = yield call(cirrusClient.delete, `/v2/domains/${domain}/users/${user}/messagesessions/${messageSessionId}`);
        if (response.data.code === 202) {
            yield put(deleteMessageSession(messageSessionId));
            
            yield put(showSnackbar({
                message: 'Message session deleted successfully',
                severity: 'success'
            }));
        }
    } catch (error) {
        console.error('Error deleting message session:', error);
        yield put(showSnackbar({
            message: 'Failed to delete message session',
            severity: 'error'
        }));
    }
}